import inspectionEdit,
       { inspectionEditActions,
         inspectionEditSelectors,  
         buildForEditAsync,
         commonChecksBeforeAddPieceAsync,
         extdoublesChecksBeforeAddPieceAsync,
         cvChecksBeforeAddPieceAsync,
         closePieceAsync,
         closeComplaintAsync,
         addComplaintAsync,
         checkComplaintBeforeAddAsync,
         gotoComplaintAsync,
         replaceScrapPriceAsync,
         checkDefectsFilledAsync,
         changeDefectAsync,
         saveInspectionAsync,
         saveImmediatelyAsync,
         deleteImmediatelyAsync,
         transferToSeverstalAsync,
         reportToEmailAsync,
         reportHistoryToEmailAsync,
         getQMMsgAsync,
         viewDOCAsync,
         downloadCertAsync as editDownloadCertAsync,
         viewCertAsync as editViewCertAsync,
         shareCertAsync as editShareCertAsync,
         checkCertAsync as editCheckCertAsync,
         downloadPhotoAsync as editDownloadPhotoAsync, 
         deleteInspectionAsync,
         changeDefectFavoriteAsync,
         addDefectAsync                                } from 'src/store/inspection/edit';

import inspectionView,
       { inspectionViewActions,
         inspectionViewSelectors,  
         openForViewAsync,
         downloadCertAsync,
         downloadPhotoAsync,
         checkCertAsync,
         viewCertAsync,
         shareCertAsync,
         viewDOCAsync as viewViewDOCAsync              } from 'src/store/inspection/view';


export const inspection = {
  edit: {
    actions: inspectionEditActions,
    selectors: inspectionEditSelectors,
    async: {
      buildForEditAsync,
      commonChecksBeforeAddPieceAsync,
      extdoublesChecksBeforeAddPieceAsync,
      cvChecksBeforeAddPieceAsync,
      closePieceAsync,
      closeComplaintAsync,
      checkComplaintBeforeAddAsync,
      addComplaintAsync,
      replaceScrapPriceAsync,
      changeDefectFavoriteAsync,
      addDefectAsync,
      changeDefectAsync,
      gotoComplaintAsync,
      checkDefectsFilledAsync,
      saveInspectionAsync,
      saveImmediatelyAsync,
      deleteImmediatelyAsync,
      transferToSeverstalAsync,
      reportToEmailAsync,
      reportHistoryToEmailAsync,
      getQMMsgAsync,
      viewDOCAsync,
      deleteInspectionAsync,
      downloadCertAsync: editDownloadCertAsync,
      viewCertAsync: editViewCertAsync,
      shareCertAsync: editShareCertAsync,
      checkCertAsync: editCheckCertAsync,
      downloadPhotoAsync: editDownloadPhotoAsync,
    }
  },
  view: {
    actions: inspectionViewActions,
    selectors: inspectionViewSelectors,
    async: {
      openForViewAsync,
      downloadCertAsync,
      checkCertAsync,
      viewCertAsync,
      shareCertAsync,
      downloadPhotoAsync,
      viewViewDOCAsync,
    }
  },
};

export const inspectionReducers = {
  inspectionEdit,
  inspectionView,
}
